import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IDescriptionWindowState } from '../../types/descriptionWindow'

const initialState: IDescriptionWindowState = {
    show: false,
    coordinates: {
        x: window.innerWidth / 2 - 300,
        y: window.innerHeight / 2 - 500,
    },
    size: { width: 300, height: 500 },
    data: {
        header: '',
        description: '',
    },
}

const descriptionWindowSlice = createSlice({
    name: 'descriptionWindowSlice',
    initialState,
    reducers: {
        show: (state) => {
            state.show = true
        },
        hide: (state) => {
            state.show = false
            state.data = { header: '', description: '' }
        },
        changeCoordinates: (
            state,
            action: PayloadAction<{ x: number; y: number }>
        ) => {
            state.coordinates = { x: action.payload.x, y: action.payload.y }
        },
        changeSize: (
            state,
            action: PayloadAction<{ width: number; height: number }>
        ) => {
            state.size = action.payload
        },
        setDescriptionData: (
            state,
            action: PayloadAction<{ header: string; description: string }>
        ) => {
            state.data = action.payload
        },
    },
})

export const { actions: descriptionWindowActions } = descriptionWindowSlice
export const { reducer: descriptionWindowReducer } = descriptionWindowSlice
